<template>
  <nav class="navbar navbar-toggleable-md navbar-inverse bg-darkgrey sticky-top box-shadow p-0">
    <button class="navbar-toggler navbar-toggler-right mt-1" type="button" data-toggle="collapse" data-target="#KeepNeyeNavbar">
      <span class="navbar-toggler-icon"></span>
    </button>
    <a class="navbar-brand" @click.prevent>
      <img src="../../../assets/KeepNeye.png" width="30" height="30" alt="">
    </a>
    <div class="collapse navbar-collapse" id="KeepNeyeNavbar">
      <ul class="navbar-nav mr-auto">
        <!-- <li class="nav-link">
          <span @click="$i18n.set('en')">EN</span>
        </li>
        <li class="nav-link">
          <span @click="$i18n.set('fr')">FR</span>
        </li> -->
        <li class="nav-item" :class="{'nav-select' : $route.name === 'Dashboard'}">
          <a class="nav-link" href="#/dashboard">{{$t('NavBar.dashboard')}}
          <i v-if="!updates" class="fas fa-circle notifier" /></a>
        </li>

        <li class="nav-item" :class="{'nav-select' : $route.name === 'OrderPending' || $route.name === 'OrderCurrent'}">
          <a class="nav-link" href="#/OrderCurrent">{{$t('NavBar.orders')}}</a>
        </li>

        <!-- <li class="nav-item" :class="{'nav-select' : $route.name === 'Marketplace'}">
          <a class="nav-link" href="#/Marketplace">{{$t('NavBar.marketplace')}}</a>
          <p v-if="marketplaceAlerts" class="alerts-bubble">{{ marketplaceAlerts }}</p>
        </li> -->

        <!-- <li v-if="hasFullAccess" class="nav-item" :class="{'nav-select' : $route.name === 'TransferPending' || $route.name === 'TransferCurrent'}">
          <a class="nav-link" href="#/TransferCurrent">{{$t('NavBar.transfer')}}</a>
        </li> -->

        <li v-if="hasFullAccess" class="nav-item" :class="{'nav-select' : $route.name === 'WallFile'}">
          <router-link class="nav-link" to="/WallFile">{{$t('NavBar.wallfile')}}</router-link>
        </li>

        <!-- <li v-if="hasFullAccess" class="nav-item" :class="{'nav-select' : $route.name === 'Drivers'}">
          <router-link class="nav-link" to="/Drivers">{{$t('NavBar.drivers')}}</router-link>
        </li>

        <li v-if="hasFullAccess" class="nav-item" :class="{'nav-select' : $route.name === 'Clients'}">
          <router-link class="nav-link" to="/Clients">{{$t('NavBar.clients')}}</router-link>
        </li> -->

        <li v-if="hasFullAccess" class="nav-item" :class="{'nav-select' : $route.name === 'Zone'}">
          <a class="nav-link" href="#/Zone">{{$t('NavBar.zone')}}</a>
        </li>

        <li v-if="hasFullAccess" class="nav-item" :class="{'nav-select' : $route.name === 'Search'}">
          <a class="nav-link" href="#/Search">{{$t('NavBar.search')}}</a>
        </li>

        <!-- <li v-if="hasFullAccess" class="nav-item" :class="{'nav-select' : $route.name === 'AddressBook'}">
          <a class="nav-link" href="#/AddressBook">{{$t('NavBar.address_book')}}</a>
        </li> -->

        <li v-if="hasFullAccess" class="nav-item" :class="{'nav-select' : $route.name === 'PendingAccounts'}">
          <a class="nav-link" href="#/PendingAccounts">{{$t('Clients.customer_account')}}</a>
        </li>

        <li v-if="hasFullAccess" class="nav-item" :class="{'nav-select' : $route.name === 'Users/Vehicles'}">
          <a class="nav-link" href="#/Users">{{$t('NavBar.users')}}</a>
        </li>

        <li v-if="hasFullAccess" class="nav-item" :class="{'nav-select' : $route.name === 'Inventory'}">
          <router-link class="nav-link" to="/Inventory">{{$t('NavBar.inventory')}}</router-link>
        </li>

        <!-- <li v-if="isAdmin && hasFullAccess" class="nav-item" :class="{'nav-select' : $route.name === 'Logs'}">
          <a class="nav-link" href="#/Logs">{{$t('NavBar.logs')}}</a>
        </li> -->

        <!-- <li v-if="isAdmin && hasFullAccess" class="nav-item" :class="{'nav-select' : $route.name === 'Reports'}">
          <a class="nav-link" href="#/Reports">{{$t('NavBar.reports')}}</a>
        </li> -->

        <li class="nav-item" :class="{'nav-select' : $route.name === 'Settings'}">
          <a class="nav-link" href="#/Settings">{{$t('NavBar.settings')}}</a>
        </li>

        <li v-if="uid === '8650fc2a-b684-496d-92fc-85c73eced49a'" class="nav-item" :class="{'nav-select' : $route.name === 'Dev'}">
          <a class="nav-link" href="#/Dev">{{$t('NavBar.dev')}}</a>
        </li>
      </ul>
      <span v-if="showCompanySwitcher" class="company-switcher mx-2">
        <label class="sr-only" for="company-switcher">{{ $t('NavBar.company') }}</label>
        <select
          id="company-switcher"
          class="company-switcher__select"
          :value="companyUID"
          @change="switchCompany"
        >
          <option
            v-for="company in availableCompanies"
            :key="company.uid"
            :value="company.uid"
          >
            {{ company.companyName || company.uid }}
          </option>
        </select>
      </span>
      <span>
        <a id="logout" class="nav-link navbar-text mx-3" href="#" @click.prevent="signOut()">{{$t('NavBar.logout')}}</a>
      </span>
    </div>
  </nav>
</template>

<script>
import Firebase from 'firebase'
import router from '../../../router'

export default {
  data () {
    return {
    }
  },
  props: {
    selected: {
      type: String,
      required: false,
      default: 'Dashboard'
    }
  },

  methods: {
    /** Update user data to:
     * Update seen in Firebase
     * Update seen in Store
     */
    updateSeenUpdates () {
      this.$store.dispatch('updateActiveCompanySeen', true)
    },

    async switchCompany (event) {
      const companyUID = event.target.value
      if (!companyUID || companyUID === this.companyUID) return

      const switched = await this.$store.dispatch('switchActiveCompany', companyUID)
      if (switched) window.location.reload()
    },

    signOut () {
      Firebase.auth().signOut().then(() => {
        this.$store.commit('clearUser')
        this.$store.commit('clearContacts')
        this.$store.commit('CLEAR_SEARCH')
        router.push({path: '/login'})
      }).catch(function () {
      })
    }
  },

  computed: {
    isUserInfoLoaded () {
      return this.$store.state.userInfo
    },
    updates () {
      if (!this.isUserInfoLoaded) return
      if (this.$store.state.authorization.isUpdateSeen) return true
    },
    marketplaceAlerts () {
      return this.$store.state.alerts.marketplace
    },
    companyUID () {
      return this.$store.state.authorization.company
    },
    availableCompanies () {
      return this.$store.state.availableCompanies || []
    },
    showCompanySwitcher () {
      return this.availableCompanies.length > 1
    },
    isAdmin () {
      return this.$store.state.authorization.role === 'Admin'
    },
    hasFullAccess () {
      return this.$store.state.userInfo.userType === 'full'
    },
    uid () {
      return this.$store.state.user.uid
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  li, a.navbar-brand{
    margin-left: 1rem;
  }
  li.dropdown.nav-item{
    cursor: pointer;
  }
  .nav-select{
    border-bottom: 3px solid #f7941e;
  }
  #KeepNeyeNavbar {
    font-size: 15px;
    overflow-x: auto;
    scrollbar-width: thin;
  }
  @media (max-width: 991px) {
    nav{
      padding-bottom: .2rem !important;
    }
  }
  #logout{
    background-color: #ff5151;
    color: white;
    height: 100%;
  }
  .nav-item {
    position: relative;
  }
  .nav-link {
    position: relative;
  }
  .notifier {
    position: absolute;
    color: red;
    font-size: 0.4rem;
    top: 8px;
  }
  .navbar-nav {
    white-space: nowrap;
  }
  .navbar-toggler-icon {
    font-size: 1rem;
  }
  .alerts-bubble {
    position: absolute;
    font-size: 10px;
    font-weight: 600;
    background: rgba(255, 0, 0, 0.9);
    padding: 0 4px;
    border-radius: 2px;
    color: white;
    right: 0;
    top: 0;
  }
  .company-switcher {
    display: inline-flex;
    align-items: center;
  }
  .company-switcher__select {
    background: #232426;
    border: 1px solid rgba(255,255,255,.35);
    border-radius: 3px;
    color: rgba(255,255,255,.9);
    font-size: 14px;
    height: 34px;
    max-width: 220px;
    padding: 0 8px;
  }
  .company-switcher__select:focus {
    border-color: #f7941e;
    outline: none;
  }
</style>
